import { useRef, useState } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import bgBack from "assets/images/foro.jpg";
import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import { Facebook, Instagram, YouTube, LinkedIn } from "@mui/icons-material";

import WhatsAppIcon from "@mui/icons-material/WhatsApp"; // Importar el icono de WhatsApp

function Information() {
  const cardRef = useRef(null);
  const [animate] = useState(false);

  const SocialIcons = () => (
    <>
      <a
        href="https://www.instagram.com/icontec.oficial/?hl=es"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Instagram fontSize="small" style={{ marginRight: 8, color: "#E4405F" }} />
      </a>
      <a
        href="https://web.facebook.com/ICONTEC.oficial/?locale=es_LA&_rdc=1&_rdr#"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Facebook fontSize="small" style={{ marginRight: 8, color: "#1877F2" }} />
      </a>
      <a
        href="https://www.youtube.com/user/icontecinternacional"
        target="_blank"
        rel="noopener noreferrer"
      >
        <YouTube fontSize="small" style={{ marginRight: 8, color: "#FF0000" }} />
      </a>
      <a href="https://co.linkedin.com/company/icontec" target="_blank" rel="noopener noreferrer">
        <LinkedIn fontSize="small" style={{ color: "#0A66C2" }} />
      </a>
    </>
  );
  const register = (e) => {
    e.preventDefault();
    window.location.href = "/registro";
  };
  return (
    <>
      <center>
        <Typography align="center" fontSize={25} fontWeight="bold">
          ¡En equipo todo es mejor!
        </Typography>

        <Typography alignItems="center" fontSize={25}>
          Invita a tu grupo de amigos y aprovechen tarifas especiales
        </Typography>

        <Button
          variant="contained"
          sx={{
            fontSize: "1.2rem",
            fontWeight: "bold",
            backgroundColor: "#0082bf",
            color: "#fff",
            padding: "12px 24px",
            borderRadius: "8px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            transition: "all 0.3s ease-in-out",
            "&:hover": {
              backgroundColor: "#e68900",
              transform: "scale(1.05)",
            },
          }}
          onClick={register}
        >
          INSCRÍBETE AQUÍ
        </Button>
        <MKBox px={1} pt={-2}>
          <center>
            <Card sx={{ padding: 2, maxWidth: "auto", mx: "auto" }}>
              <CardContent>
                <Typography variant="body1" color="text">
                  O puedes comunicarte directamente con nuestras ejecutivas:
                </Typography>

                <Box display="flex" flexDirection="column" alignItems="center" mt={2}>
                  {/* Contacto 1 */}
                  <Box display="flex" alignItems="center" justifyContent="center" mb={2}>
                    <WhatsAppIcon color="success" />
                    <Typography variant="body2" color="text" ml={1}>
                      Maria Camila Guerrero - 3104780772
                    </Typography>
                    <Button
                      variant="text"
                      color="info"
                      href="https://wa.me/3104780772"
                      target="_blank"
                      sx={{ ml: 2 }}
                    >
                      Contactar
                    </Button>
                  </Box>

                  {/* Contacto 2 */}
                  <Box display="flex" alignItems="center" justifyContent="center">
                    <WhatsAppIcon color="success" />
                    <Typography variant="body2" color="text" ml={1}>
                      Paula Guerrero - 3138872014
                    </Typography>
                    <Button
                      variant="text"
                      color="info"
                      href="https://wa.me/message/FP4JZQV4RXVMJ1"
                      target="_blank"
                      sx={{ ml: 2 }}
                    >
                      Contactar
                    </Button>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </center>
        </MKBox>
      </center>

      <MKBox id="rotating-card-section">
        <MKBox component="section" py={6} my={6}>
          <Container>
            <Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto" }}>
              <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
                <div ref={cardRef} className={animate ? "highlight-animation" : ""}>
                  <RotatingCard>
                    <RotatingCardFront
                      image={bgBack}
                      icon="event"
                      title={
                        <>
                          XVI Foro Internacional de Calidad
                          <br />
                          2025
                        </>
                      }
                      description="Únete a líderes y expertos en calidad para discutir las tendencias y desafíos actuales."
                    />
                    <RotatingCardBack
                      image={bgBack}
                      title="Más Información"
                      description="Conoce toda la información de nuestro evento"
                      action={{
                        type: "external",
                        route:
                          "https://medios.icontec.org/documentos/BROCHURE-FIC-XVI-2025-General.pdf ",
                        label: "Haz clic aquí",
                      }}
                    />
                  </RotatingCard>
                </div>
              </Grid>
              <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <DefaultInfoCard
                      icon="schedule"
                      title="Fecha y Hora"
                      description="Es del 27 al 29  de agosto 2025, de 8:00 AM a 5:00 PM."
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <DefaultInfoCard
                      icon="location_on"
                      title="Web"
                      description="Online Plataforma de streaming de ICONTEC"
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
                  <Grid item xs={12} md={6}>
                    <DefaultInfoCard
                      icon="people"
                      title="Público Objetivo"
                      description="Estudiantes de Pregrado / Postgrado"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <DefaultInfoCard
                      icon="star"
                      title="Temáticas Principales"
                      description="Calidad 4.0, transformación digital, impacto de la Inteligencia Artificial en la actualización de las normas de Sistemas de Gestión."
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
                  <Grid item xs={12} md={6}>
                    <DefaultInfoCard
                      icon="contact_mail"
                      title="Contacto"
                      description="Línea de atención al cliente Tel . #426 / 01 8000 94 9000 Escríbanos a: cliente@icontec.org"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <DefaultInfoCard
                      icon="share"
                      title="Síguenos en Redes Sociales"
                      description={
                        <>
                          Mantente al día con las últimas noticias del evento en nuestras redes
                          sociales. <br />
                          <SocialIcons />
                        </>
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
      </MKBox>

      {/* Estilos de la animación */}
      <style>
        {`
          .highlight-animation {
            animation: pulse 1s ease-in-out;
          }

          @keyframes pulse {
            0% { transform: scale(1); box-shadow: 0px 0px 10px rgba(0, 130, 191, 0.5); }
            50% { transform: scale(1.1); box-shadow: 0px 0px 20px rgba(0, 130, 191, 0.8); }
            100% { transform: scale(1); box-shadow: 0px 0px 10px rgba(0, 130, 191, 0.5); }
          }
        `}
      </style>
    </>
  );
}

export default Information;
